import React from "react";
import { Skeleton } from "@mui/material";

const TabSkeleton = ({
  lines = 10,
}) => {
  return (
    <>
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton
          key={index}
          animation="wave"
          variant="text"
          sx={{ fontSize: "1rem" }}
          width={index % 3 === 0 ? "30%" : "80%"}
        />
      ))}
    </>
  );
};

export default TabSkeleton;